import React from "react";
import Loader from "../../components/general/Loader";
import { Subscribe } from "unstated";
import AuthContainer from "../../state/containers/AuthContainer";
import { Redirect, RouteComponentProps } from "react-router";
import UserContainer from "../../state/containers/UserContainer";

interface RouteProps {
    invitationCode?: string
}

interface SingleSignOnRedirectorProps extends RouteComponentProps<RouteProps> { }

interface SingleSignOnRedirectorChildProps {
    invitationCode?: string,
    authContainer: AuthContainer,
    userContainer: UserContainer,
    history: any
}

class SingleSignOnSignUpRedirector extends React.Component<SingleSignOnRedirectorProps> {
    render() {
        return (
            <Subscribe to={[AuthContainer, UserContainer]}>
                {(authContainer: AuthContainer, userContainer: UserContainer) =>
                    <SingleSignOnSignUpRedirectorChild
                        authContainer={authContainer}
                        invitationCode={this.props.match.params.invitationCode}
                        userContainer={userContainer}
                        history={this.props.history}
                    />}
            </Subscribe>
        );
    }
};

class SingleSignOnSignUpRedirectorChild extends React.Component<SingleSignOnRedirectorChildProps> {
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get("email");
        const token = urlParams.get("token");
        if (this.props.invitationCode != null) {
            this.props.authContainer.signInWithSingleSignOn(email, token);
        }
    }
    render() {
        if (this.props.authContainer.state.isAuthenticated === true && this.props.invitationCode != null) {
            return <Redirect to={`/acceptInvitation/${this.props.invitationCode}`} />
        }
        return (<Loader />)
    }
}

export default SingleSignOnSignUpRedirector;
